<template>
  <div>
    <StepHeader
      :title="title"
    />

    <StepContent
      width="xl"
    >
      <AppButtonList
        :columns="3"
        :buttons="buttons"
        :value="source_of_income"
        @input="handleClick($event)"
      />
    </StepContent>

    <StepFooter>
      <AppButtonContinue
        v-data-layer
        :data-layer="[datalayerContinue, datalayerButtonList]"
        @click="$emit('next')"
      >
        Continue
      </AppButtonContinue>

      <StepTooltip>
        The status of your employment helps us determine the
        appropriate loan program for you.
      </StepTooltip>
    </StepFooter>
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepHeader from '@/components/common/step/StepHeader'
import StepTooltip from '@/components/common/step/StepTooltip'

export default {
  // Name
  name: 'employment-status-other',

  // Components
  components: {
    AppButtonContinue,
    AppButtonList,
    StepContent,
    StepFooter,
    StepHeader,
    StepTooltip
  },

  // Data
  data () {
    return {
      datalayerStepName: 'cosigner_emp_status',
      fieldName: 'source_of_income',
      datalayerList: undefined,
      defaultSelected: false,
      title: 'What Is Your Income Source?',
      buttons: [{
        text: 'Spousal Support / Alimony',
        value: 'Spousal Support/Alimony',
        datalayer: 'spousalsupport'
      }, {
        text: 'Child Support',
        value: 'Child Support',
        datalayer: 'childsupport'
      }, {
        text: 'Social Assistance / Welfare',
        value: 'Social Assistance/Welfare',
        datalayer: 'socialassistance'
      }, {
        text: 'Maternity Leave',
        value: 'Maternity Leave',
        datalayer: 'maternityleave'
      }, {
        text: 'Baby Bonus / Child Tax',
        value: 'Baby Bonus/Child Tax',
        datalayer: 'childtax'
      }, {
        text: 'Unemployed / EI',
        value: 'Unemployed/EI',
        datalayer: 'unemployed'
      }, {
        text: 'Other / Not Listed',
        value: 'Other',
        datalayer: 'notlisted'
      }]
    }
  },

  // Computed
  computed: {
    source_of_income () {
      return this.$store.state.application.source_of_income_b
    },

    datalayerContinue () {
      return `${this.datalayerStepName}_other_continue`
    },

    selectedButton () {
      if (!this[this.fieldName]) return
      for (let i in this.buttons) {
        if (this.buttons[i].value === this[this.fieldName]) {
          return this.buttons[i]
        }
      }
    },

    datalayerButtonList () {
      if (!this.selectedButton) return
      const datalayer = this.selectedButton.datalayer
      return `${this.datalayerStepName}_${datalayer}`
    }
  },

  // Created
  created () {
    if (!this[this.fieldName]) {
      this.handleUpdateValue(this.buttons[0].value)
      this.defaultSelected = true
    } else {
      this.handleUpdateValue(this[this.fieldName])
    }
  },

  // Methods
  methods: {
    handleClick (event) {
      this.handleUpdateValue(event)
      this.defaultSelected = false
    },

    handleUpdateValue (value) {
      this.$store.updateApplication(this.fieldName, value)
      this.$store.updateApplication('source_of_income_b', value)
      this.$store.updateApplication('company_name', value)
      this.$store.updateApplication('job_title', value)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
